export default "__VITE_ASSET__tawLNb1Y__"